import { render, staticRenderFns } from "./BotChat.vue?vue&type=template&id=608a70ea&scoped=true"
import script from "./BotChat.vue?vue&type=script&lang=js"
export * from "./BotChat.vue?vue&type=script&lang=js"
import style0 from "./BotChat.vue?vue&type=style&index=0&id=608a70ea&prod&scoped=true&lang=css"
import style1 from "./BotChat.vue?vue&type=style&index=1&id=608a70ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a70ea",
  null
  
)

export default component.exports